// Add your custom JS here
//slider section features feedinglittles
jQuery(document).ready(function(){
    jQuery(".testimonials-custom-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false
    });
  });